// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"aee8a57c","917":"181261cf"}[chunkId] + ".chunk.js";
};